import React from 'react';
import './Consent.less';
import {Checkbox} from "elements/checkbox/Checkbox.tsx";

export const Consent = ({isChecked, caption}) => {
	return <div className="consent">
        <span className="consent__checkbox">
            <Checkbox isChecked={isChecked} isSecondary/>
        </span>
		<span className="consent__caption">
            {caption}
        </span>
	</div>
}
